import React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Row from 'components/Row';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
import Image from 'components/Image';

import 'coaching/components/styles/CoachingHomeFreeTrialCard.scss';

export type Props = {
  button?: React.ReactElement;
  timeText: string;
  titleText: string;
  bodyText: string;
  image: string;
};
/**
 * A card that appears in the session container for free trials.
 */
export default function CoachingHomeFreeTrialCard(props: Props) {
  return (
    <Box textAlign="left">
      <BoxBody size="xsmall">
        <MediaObject className="CoachingHomeFreeTrialCard-innerCardSection" figure="right">
          <div className="CoachingHomeFreeTrialCard-cardCopy">
            <Row size="xxsmall">
              <Text element="div" color="graphite">
                {props.timeText}
              </Text>
            </Row>
            <Row size="small" className="CoachingHomeFreeTrialCard-cardCopy-mainText">
              <Text weight="bold">{props.titleText}</Text> <Text>{props.bodyText}</Text>
            </Row>
            <div>{props.button}</div>
          </div>
          <Image src={props.image} width={120} />
        </MediaObject>
      </BoxBody>
    </Box>
  );
}
